/* What is FiGGYZ - Interactive JavaScript */
/* Apple-inspired parallax scrolling and animations */

(function() {
  'use strict';

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    initializeParallaxEngine();
    initializeAnimations();
    initializeFiggyzDex(); // Replace carousel with FiggyzDex
    initializeFranchiseGrid(); // Load franchise cards from API
    initializeProductRotation();
    initializeScrollIndicator();
    initializeParticleSystem();
  });

  // Parallax Scrolling Engine
  function initializeParallaxEngine() {
    const sections = document.querySelectorAll('.figgyz-showcase-section');
    const parallaxElements = [];

    // Define parallax speeds for different elements
    const parallaxConfig = {
      '.hero-product': { speed: 0.5, offset: 0 },
      '.particle': { speed: 0.3, offset: 0 },
      '.problem-right': { speed: 0.7, offset: 100 },
      '.feature-card': { speed: 0.9, offset: 50 },
      '.mount-item': { speed: 0.8, offset: 30 },
      '.chase-tier': { speed: 0.85, offset: 40 },
      '.community-item': { speed: 0.9, offset: 20 }
    };

    // Collect all parallax elements
    Object.keys(parallaxConfig).forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(el => {
        parallaxElements.push({
          element: el,
          config: parallaxConfig[selector],
          originalY: el.getBoundingClientRect().top + window.pageYOffset
        });
      });
    });

    // Smooth parallax on scroll
    let ticking = false;
    function updateParallax() {
      const scrollY = window.pageYOffset;

      parallaxElements.forEach(item => {
        const { element, config, originalY } = item;
        const elementTop = originalY - scrollY;
        const elementVisible = elementTop < window.innerHeight && elementTop > -element.offsetHeight;

        if (elementVisible) {
          const yPos = -(scrollY - originalY) * (1 - config.speed);
          element.style.transform = `translateY(${yPos}px)`;
        }
      });

      ticking = false;
    }

    function requestTick() {
      if (!ticking) {
        window.requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }

    window.addEventListener('scroll', requestTick);
    window.addEventListener('resize', () => {
      // Recalculate positions on resize
      parallaxElements.forEach(item => {
        item.originalY = item.element.getBoundingClientRect().top + window.pageYOffset;
      });
      requestTick();
    });
  }

  // Intersection Observer for scroll-triggered animations
  function initializeAnimations() {
    const animatedElements = document.querySelectorAll('[data-aos]');
    
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const element = entry.target;
          const delay = element.getAttribute('data-aos-delay') || 0;
          
          setTimeout(() => {
            element.classList.add('aos-animate');
            
            // Add specific animations based on data-aos value
            const animationType = element.getAttribute('data-aos');
            switch(animationType) {
              case 'fade-up':
                element.style.animation = 'fadeInUp 0.8s ease-out forwards';
                break;
              case 'scale-in':
                element.style.animation = 'scaleIn 0.6s ease-out forwards';
                break;
              case 'slide-left':
                element.style.animation = 'slideInLeft 0.8s ease-out forwards';
                break;
              case 'slide-right':
                element.style.animation = 'slideInRight 0.8s ease-out forwards';
                break;
            }
          }, delay);
          
          observer.unobserve(element);
        }
      });
    }, observerOptions);

    animatedElements.forEach(el => observer.observe(el));

    // Add custom animations
    addCustomAnimations();
  }

  function addCustomAnimations() {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes scaleIn {
        from {
          opacity: 0;
          transform: scale(0.8);
        }
        to {
          opacity: 1;
          transform: scale(1);
        }
      }
      
      @keyframes slideInLeft {
        from {
          opacity: 0;
          transform: translateX(-50px);
        }
        to {
          opacity: 1;
          transform: translateX(0);
        }
      }
      
      @keyframes slideInRight {
        from {
          opacity: 0;
          transform: translateX(50px);
        }
        to {
          opacity: 1;
          transform: translateX(0);
        }
      }
      
      @keyframes pulseGlow {
        0%, 100% {
          box-shadow: 0 0 20px rgba(225, 72, 38, 0.3);
        }
        50% {
          box-shadow: 0 0 40px rgba(225, 72, 38, 0.6);
        }
      }
    `;
    document.head.appendChild(style);
  }

  // FiggyzDex Implementation - Simple Pokedex-style listing
  function initializeFiggyzDex() {
    const dexContainer = document.getElementById('figgyz-dex');
    if (!dexContainer) return;

    // DOM elements
    const dexGrid = document.getElementById('dex-grid');
    const dexCount = document.querySelector('.dex-count');

    // Fetch and display all products
    async function loadFiggyzDex() {
      try {
        // Load all pages to get complete list
        let allProducts = [];
        let page = 1;
        let hasMore = true;

        while (hasMore && page <= 10) { // Limit to 10 pages for safety
          const response = await fetch(`https://api.figgyz.com/api/v1/products/figgydex?per_page=50&page=${page}`);
          const result = await response.json();
          
          if (result.data && result.data.length > 0) {
            allProducts = [...allProducts, ...result.data];
            page++;
            hasMore = result.data.length === 50; // If we got 50, there might be more
          } else {
            hasMore = false;
          }
        }
        
        // Update count
        dexCount.textContent = `${allProducts.length} FiGGYZ Discovered`;
        
        // Display all products
        displayProducts(allProducts);
        
      } catch (error) {
        console.error('Error loading FiggyzDex:', error);
        dexGrid.innerHTML = '<div class="dex-error">Failed to load FiggyzDex. Please try again later.</div>';
      }
    }

    // Display products in grid
    function displayProducts(products) {
      if (products.length === 0) {
        dexGrid.innerHTML = '<div class="dex-no-results">No FiGGYZ found.</div>';
        return;
      }

      const productsHTML = products.map((product, index) => {
        // Extract data from API structure
        const attrs = product.attributes;
        const imageUrl = attrs.images && attrs.images.data && attrs.images.data[0] 
          ? attrs.images.data[0].attributes.url 
          : '';
        const fullName = attrs.name || 'Unknown FiGGYZ';
        
        // Split name to extract character name and number
        const nameParts = fullName.split(' - ');
        const characterName = nameParts[0] || fullName;
        const franchiseName = nameParts[1] || '';
        
        // Get wave information from categories
        const mainCategory = attrs.categories && attrs.categories.length > 0 
          ? attrs.categories[attrs.categories.length - 1].name 
          : 'Unknown Series';
        
        // Combine franchise and wave info
        const franchiseDisplay = franchiseName ? `${franchiseName}<br/>Wave 1` : `${mainCategory}<br/>Wave 1`;
        
        return `
          <div class="dex-item" data-product-id="${product.id}">
            <div class="dex-item-number">#${String(index + 1).padStart(3, '0')}</div>
            <img src="${imageUrl}" alt="${characterName}">
            <div class="dex-item-name">${characterName}</div>
            <div class="dex-item-franchise">${franchiseDisplay}</div>
          </div>
        `;
      }).join('');

      dexGrid.innerHTML = productsHTML;

      // Add click handlers for future modal integration
      document.querySelectorAll('.dex-item').forEach(item => {
        item.addEventListener('click', function() {
          const productId = this.getAttribute('data-product-id');
          console.log('FiggyzDex Entry:', productId);
          // Future: Open product modal
        });
      });
      
      // Apply stagger animations to newly created dex items (very fast)
      if (window.FiggyzScrollAnimations && window.FiggyzScrollAnimations.animateStagger) {
        const newDexItems = document.querySelectorAll('.dex-item');
        window.FiggyzScrollAnimations.animateStagger(newDexItems, 15, 'scale(0.98) translateY(8px)', 'scale(1) translateY(0px)');
      }
    }

    // Initialize
    loadFiggyzDex();
  }

  // Franchise Grid Implementation - Load from API
  function initializeFranchiseGrid() {
    const franchiseGrid = document.getElementById('franchise-grid');
    if (!franchiseGrid) return;

    // Fetch and display franchise cards
    async function loadFranchiseCards() {
      try {
        const response = await fetch('https://api.figgyz.com/api/v1/categories?per_page=25&page=1');
        const result = await response.json();
        
        if (result.data && result.data.length > 0) {
          displayFranchiseCards(result.data);
        } else {
          franchiseGrid.innerHTML = '<div class="franchise-loading">No franchises found.</div>';
        }
        
      } catch (error) {
        console.error('Error loading franchise cards:', error);
        franchiseGrid.innerHTML = '<div class="franchise-loading">Failed to load franchises.</div>';
      }
    }

    // Display franchise cards
    function displayFranchiseCards(franchises) {
      // Filter franchises that have both logo and background images
      const validFranchises = franchises.filter(franchise => {
        const attrs = franchise.attributes;
        return attrs.app_logo_image && attrs.app_background_image;
      });

      if (validFranchises.length === 0) {
        franchiseGrid.innerHTML = '<div class="franchise-loading">No franchise cards available.</div>';
        return;
      }

      let franchiseHTML = validFranchises.map(franchise => {
        const attrs = franchise.attributes;
        const name = attrs.name || 'Unknown Franchise';
        const logoImage = attrs.app_logo_image;
        const backgroundImage = attrs.app_background_image;
        
        // Apply Cloudflare image optimization
        const optimizedBackgroundImage = window.CLOUDFLARE_IMAGE_CONFIG && window.CLOUDFLARE_IMAGE_CONFIG.optimize 
          ? window.CLOUDFLARE_IMAGE_CONFIG.optimize(backgroundImage, { width: 600, quality: 85, fit: 'cover' })
          : backgroundImage;
        
        const optimizedLogoImage = window.CLOUDFLARE_IMAGE_CONFIG && window.CLOUDFLARE_IMAGE_CONFIG.optimize 
          ? window.CLOUDFLARE_IMAGE_CONFIG.optimize(logoImage, { width: 400, quality: 90, fit: 'scale-down' })
          : logoImage;
        
        return `
          <div class="franchise-card" data-franchise-id="${franchise.id}" data-franchise-name="${name}">
            <img src="${optimizedBackgroundImage}" alt="${name} Background" class="franchise-background">
            <div class="franchise-overlay"></div>
            <img src="${optimizedLogoImage}" alt="${name} Logo" class="franchise-logo">
          </div>
        `;
      }).join('');

      // Calculate how many placeholders we need to reach a multiple of 5
      const currentCount = validFranchises.length;
      const remainder = currentCount % 5;
      const placeholdersNeeded = remainder === 0 ? 0 : 5 - remainder;

      // Add placeholder cards for "COMING SOON!"
      for (let i = 0; i < placeholdersNeeded; i++) {
        franchiseHTML += `
          <div class="franchise-card franchise-coming-soon">
            <div class="franchise-overlay"></div>
            <div class="coming-soon-text">COMING SOON!</div>
          </div>
        `;
      }

      franchiseGrid.innerHTML = franchiseHTML;

      // Function to clean up search strings for better search results
      // Examples: "Sonic the Hedgehog (Modern)" → "Sonic Hedgehog Modern"
      //           "Street Fighter [Wave 1]" → "Street Fighter Wave 1"
      //           "Shin Megami Tensei V Vengence" → "Shin Megami Tensei Vengence"
      function cleanSearchString(searchString) {
        if (!searchString) return '';
        
        return searchString
          // Remove brackets and their contents: (Modern), [Classic], etc.
          .replace(/[\(\)\[\]\{\}]/g, '')
          // Remove common words that cause too many matches
          .replace(/\bthe\b/gi, '')
          .replace(/\band\b/gi, '')
          .replace(/\bof\b/gi, '')
          .replace(/\ba\b/gi, '')
          .replace(/\ban\b/gi, '')
          // Remove single character words (like V, X, I) that cause too many matches
          .replace(/\b[a-zA-Z]\b/g, '')
          // Clean up extra spaces
          .replace(/\s+/g, ' ')
          .trim();
      }

      // Add click handlers to open search with franchise name
      document.querySelectorAll('.franchise-card').forEach(card => {
        card.addEventListener('click', function() {
          const franchiseId = this.getAttribute('data-franchise-id');
          const franchiseName = this.getAttribute('data-franchise-name');
          
          // Check if this is a "Coming Soon" card
          if (this.classList.contains('franchise-coming-soon')) {
            return; // Don't do anything for coming soon cards
          }
          
          // Open search modal with cleaned franchise name
          if (franchiseName && window.openSearchWithQuery) {
            const cleanedSearchString = cleanSearchString(franchiseName);
            // Pass the current URL as return URL
            window.openSearchWithQuery(cleanedSearchString, window.location.pathname);
          } else if (franchiseName) {
            // Fallback: Open search and set query manually
            const searchButton = document.getElementById('searchButton');
            const searchInput = document.getElementById('searchInput');
            const cleanedSearchString = cleanSearchString(franchiseName);
            
            // Store return URL for fallback
            window.searchReturnUrl = window.location.pathname;
            
            if (searchButton) {
              searchButton.click();
              
              // Set the search query after a small delay to ensure modal is open
              setTimeout(() => {
                if (searchInput) {
                  searchInput.value = cleanedSearchString;
                  // Trigger input event to perform search
                  const event = new Event('input', { bubbles: true });
                  searchInput.dispatchEvent(event);
                  
                  // Trigger Enter key
                  const enterEvent = new KeyboardEvent('keypress', {
                    key: 'Enter',
                    keyCode: 13,
                    which: 13,
                    bubbles: true
                  });
                  searchInput.dispatchEvent(enterEvent);
                }
              }, 100);
            }
          }
        });
      });
    }

    // Initialize
    loadFranchiseCards();
  }

  // 360° Product Rotation
  function initializeProductRotation() {
    const product360 = document.getElementById('hero-product-360');
    if (!product360) return;

    let rotation = 0;
    let isRotating = true;

    // Create sprite sheet animation or video element
    const rotatingProduct = product360.querySelector('.rotating-product');
    
    // If we have a 360 video, use it
    if (rotatingProduct && rotatingProduct.tagName === 'VIDEO') {
      rotatingProduct.loop = true;
      rotatingProduct.muted = true;
      rotatingProduct.play();
    } else {
      // Manual rotation animation
      function rotateProduct() {
        if (isRotating) {
          rotation += 1;
          rotatingProduct.style.transform = `rotateY(${rotation}deg)`;
          requestAnimationFrame(rotateProduct);
        }
      }

      // Start rotation
      rotateProduct();

      // Interactive rotation on hover/drag
      let isDragging = false;
      let startX = 0;
      let currentRotation = 0;

      product360.addEventListener('mousedown', (e) => {
        isDragging = true;
        isRotating = false;
        startX = e.clientX;
        currentRotation = rotation;
        product360.style.cursor = 'grabbing';
      });

      document.addEventListener('mousemove', (e) => {
        if (isDragging) {
          const deltaX = e.clientX - startX;
          rotation = currentRotation + deltaX;
          rotatingProduct.style.transform = `rotateY(${rotation}deg)`;
        }
      });

      document.addEventListener('mouseup', () => {
        if (isDragging) {
          isDragging = false;
          product360.style.cursor = 'grab';
          setTimeout(() => {
            isRotating = true;
            rotateProduct();
          }, 2000);
        }
      });
    }
  }

  // Scroll Indicator
  function initializeScrollIndicator() {
    const scrollIndicator = document.querySelector('.scroll-indicator');
    if (!scrollIndicator) return;

    // PERFORMANCE: Throttled scroll handler using requestAnimationFrame
    const updateScrollIndicator = (() => {
      let rafId = null;
      return () => {
        if (rafId) return;
        rafId = requestAnimationFrame(() => {
          rafId = null;
          const scrolled = window.pageYOffset;
          const opacity = Math.max(0, 1 - scrolled / 300);
          scrollIndicator.style.opacity = opacity;
          
          if (opacity === 0) {
            scrollIndicator.style.pointerEvents = 'none';
          }
        });
      };
    })();

    window.addEventListener('scroll', updateScrollIndicator, { passive: true });

    scrollIndicator.addEventListener('click', () => {
      const nextSection = document.getElementById('problem');
      if (nextSection) {
        nextSection.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

  // Particle System
  function initializeParticleSystem() {
    const particleSystem = document.querySelector('.particle-system');
    if (!particleSystem) return;

    const particleCount = 20;
    const particles = [];

    // Create particles
    for (let i = 0; i < particleCount; i++) {
      const particle = document.createElement('div');
      particle.className = 'particle';
      particle.style.left = Math.random() * 100 + '%';
      particle.style.animationDelay = Math.random() * 20 + 's';
      particle.style.animationDuration = (15 + Math.random() * 10) + 's';
      
      // Random size
      const size = 2 + Math.random() * 4;
      particle.style.width = size + 'px';
      particle.style.height = size + 'px';
      
      // Random color from brand palette
      const colors = ['#E14826', '#FCAA1A', '#CC3530'];
      particle.style.background = colors[Math.floor(Math.random() * colors.length)];
      
      particleSystem.appendChild(particle);
      particles.push(particle);
    }
  }

  // Smooth scroll behavior for navigation
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

  // Performance optimization: Throttle scroll events
  function throttle(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Add loading animation
  window.addEventListener('load', () => {
    document.body.classList.add('loaded');
    
    // Trigger hero animations
    setTimeout(() => {
      document.querySelector('.hero-content').classList.add('animate-in');
      document.querySelector('.hero-product').classList.add('animate-in');
    }, 100);
  });

  // Visual Features Section Enhancements
  function initVisualFeatures() {
    const featureCards = document.querySelectorAll('.visual-features-grid .feature-card');
    
    if (!featureCards.length) return;
    
    // Enhanced hover effects with tilt
    featureCards.forEach(card => {
      let bounds;
      
      function rotateToMouse(e) {
        const mouseX = e.clientX;
        const mouseY = e.clientY;
        const leftX = mouseX - bounds.x;
        const topY = mouseY - bounds.y;
        const center = {
          x: leftX - bounds.width / 2,
          y: topY - bounds.height / 2
        };
        const distance = Math.sqrt(center.x**2 + center.y**2);
        
        card.style.transform = `
          scale3d(1.02, 1.02, 1.02)
          rotate3d(
            ${center.y / 100},
            ${-center.x / 100},
            0,
            ${Math.log(distance) * 2}deg
          )
        `;
      }
      
      card.addEventListener('mouseenter', (e) => {
        bounds = card.getBoundingClientRect();
        document.addEventListener('mousemove', rotateToMouse);
      });
      
      card.addEventListener('mouseleave', () => {
        document.removeEventListener('mousemove', rotateToMouse);
        card.style.transform = '';
      });
    });
    
    // Lazy loading for feature images
    const imageObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src && !img.src) {
            img.src = img.dataset.src;
            img.classList.add('loaded');
          }
          imageObserver.unobserve(img);
        }
      });
    }, {
      rootMargin: '50px'
    });
    
    document.querySelectorAll('.feature-image img').forEach(img => {
      imageObserver.observe(img);
    });
    
    // Click to expand feature cards on mobile
    if (window.innerWidth <= 768) {
      featureCards.forEach(card => {
        card.addEventListener('click', () => {
          card.classList.toggle('expanded');
        });
      });
    }
  }
  
  // Initialize visual features when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVisualFeatures);
  } else {
    initVisualFeatures();
  }

  // Go to Top Button Implementation
  function initializeGoToTop() {
    const goToTopButton = document.getElementById('goToTop');
    if (!goToTopButton) return;

    let isScrolling = false;
    
    // Show/hide button based on scroll position
    function updateButtonVisibility() {
      const scrollY = window.pageYOffset || document.documentElement.scrollTop;
      const threshold = 600; // Show button after scrolling 600px
      
      if (scrollY > threshold) {
        goToTopButton.classList.add('visible');
      } else {
        goToTopButton.classList.remove('visible');
      }
    }
    
    // Adjust position based on cart bar visibility
    function adjustForCartBar() {
      const cartBar = document.getElementById('cartBar');
      if (cartBar) {
        // For now, if cart bar exists at all, assume it's visible (due to debug CSS)
        // This ensures the button is always positioned above the cart bar
        goToTopButton.style.bottom = window.innerWidth <= 768 ? '90px' : '100px';
        
        // Original visibility check code kept for when debug CSS is removed
        /*
        const computedStyle = window.getComputedStyle(cartBar);
        const transform = computedStyle.transform || computedStyle.webkitTransform || '';
        const isVisible = transform === 'none' || transform.includes('matrix(1, 0, 0, 1, 0, 0)') || 
                         cartBar.classList.contains('has-items') ||
                         computedStyle.transform === 'translateY(0)';
        
        if (isVisible) {
          goToTopButton.style.bottom = window.innerWidth <= 768 ? '90px' : '100px';
        } else {
          goToTopButton.style.bottom = window.innerWidth <= 768 ? '20px' : '30px';
        }
        */
      } else {
        // No cart bar - normal position
        goToTopButton.style.bottom = window.innerWidth <= 768 ? '20px' : '30px';
      }
    }

    // Throttled scroll handler for performance
    function handleScroll() {
      if (!isScrolling) {
        window.requestAnimationFrame(() => {
          updateButtonVisibility();
          isScrolling = false;
        });
        isScrolling = true;
      }
    }

    // Smooth scroll to top
    function scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }

    // Event listeners
    window.addEventListener('scroll', handleScroll, { passive: true });
    goToTopButton.addEventListener('click', scrollToTop);
    
    // Monitor cart bar changes
    const cartBarObserver = new MutationObserver(() => {
      adjustForCartBar();
    });
    
    const cartBar = document.getElementById('cartBar');
    if (cartBar) {
      cartBarObserver.observe(cartBar, {
        attributes: true,
        attributeFilter: ['class', 'style'],
        attributeOldValue: true
      });
    }
    
    // Also listen for window resize to adjust positioning
    window.addEventListener('resize', adjustForCartBar);

    // Initial checks
    updateButtonVisibility();
    adjustForCartBar();
  }

  // Initialize go to top when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeGoToTop);
  } else {
    initializeGoToTop();
  }

})();